<script>
  import { onMount } from "svelte";
  import TopProducts from "./TopProducts.svelte";
  import TopCategories from "./TopCategories.svelte";
  import TopCustomers from "./TopCustomers.svelte";
  import TopSources from "./TopSources.svelte";
  import {M} from "../../external";

  export let tab,
    filters = [],
    funnel = null,
    period = null,
    options = {}

  let instance;

  export function reload() {
    instance.reload();
  }

  let changeTab = (newTab) => {
    if (tab === newTab) {
      return;
    }
    tab = newTab;
  };

  onMount(() => {
    tab = options.products === false ? "users" : tab || "products";
  });
</script>

{#if options.navigation === 'big'}
<div class="col20 f-left funnels-box-wrapper t-left flex flex-row align-center" style="vertical-align: middle;">
  <h3 class="f-left roboto inline-block flex-none">{M.TOP_PERFORMERS}</h3>
  <div class="upper-navigation upper-navigation-full inner-upper-nav col20">
    <ul class="t-left ml-25">
      {#if options.products !== false}
        <li><a on:click={() => changeTab("products")} class:active={tab === "products"}>{M.TOP_PRODUCTS}</a></li>
      {/if}
      <!--<li><a on:click={() => changeTab("categories")} class:active={tab === "categories"}>Top Categories</a></li>-->
      {#if options.users !== false}
        <li><a on:click={() => changeTab("users")} class:active={tab === "users"}>{M.TOP_USERS}</a></li>
      {/if}
      {#if options.sources !== false}
        <li><a on:click={() => changeTab("sources")} class:active={tab === "sources"}>{M.TOP_SOURCES}</a></li>
      {/if}
    </ul>
  </div>
</div>
{:else}
<div class="upper-navigation upper-navigation-full inner-upper-nav col20">
  <ul>
    {#if options.products !== false}
      <li><a on:click={() => changeTab("products")} class:active={tab === "products"}>{M.TOP_PRODUCTS}</a></li>
    {/if}
    <!--<li><a on:click={() => changeTab("categories")} class:active={tab === "categories"}>Top Categories</a></li>-->
    {#if options.users !== false}
      <li><a on:click={() => changeTab("users")} class:active={tab === "users"}>{M.TOP_USERS}</a></li>
    {/if}
    {#if options.sources !== false}
      <li><a on:click={() => changeTab("sources")} class:active={tab === "sources"}>{M.TOP_SOURCES}</a></li>
    {/if}
  </ul>
</div>
{/if}

{#if tab === "products" && options.products !== false}
  <TopProducts bind:this={instance} filters={filters} funnel={funnel} period={period} />
{:else if tab === "categories" && options.categories !== false}
  <TopCategories />
{:else if tab === "users" && options.users !== false}
  <TopCustomers bind:this={instance} filters={filters} funnel={funnel} period={period} />
{:else if tab === "sources" && options.sources !== false}
  <TopSources bind:this={instance} filters={filters} funnel={funnel} period={period} />
{/if}
